import { render, staticRenderFns } from "./ResumoGlosas.vue?vue&type=template&id=6a4f46f6"
import script from "./ResumoGlosas.vue?vue&type=script&lang=js"
export * from "./ResumoGlosas.vue?vue&type=script&lang=js"
import style0 from "./ResumoGlosas.vue?vue&type=style&index=0&id=6a4f46f6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports